import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import AIReviewedChip from "./AIReviewedChip";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const ClientPriorityTableSection = ({
  theme,
  priorityRows,
  entityId,
  AiSectionFeedback,
  requestId,
  uiSectionKey,
  userEmail,
}) => {
  return (
    <Card sx={{ borderRadius: 2, boxShadow: "0 8px 20px rgba(15,23,42,0.06)" }}>
      <CardContent>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: theme.palette.primary.main,

              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            2026 Client Priority &amp; Risk <AIReviewedChip />
            <DataSourceIcon mode="light" sources={["Salesforce", "Nasdaq"]} />
          </Typography>

          <AiSectionFeedback
            sectionName="ClientPortfolio - 2025 Client Priority & Risk (AI-reviewed)"
            entityId={entityId}
            variant="light"
            requestId={requestId}
            uiSectionKey={uiSectionKey}
            userEmail={userEmail}
          />
        </Box>

        <Box sx={{ overflowX: "auto" }}>
          <Table
            size="small"
            sx={{
              minWidth: 900,
              borderCollapse: "separate",
              borderSpacing: 0,
              "& th, & td": { borderBottom: "1px solid #e5e7eb" },
              "& tbody tr:hover": { backgroundColor: "#f9fafb" },
            }}
          >
            <TableHead>
              <TableRow>
                {[
                  "Priority",
                  "Asset Class",
                  "Segment Goals (Next Best Actions)",
                  "Primary Lead",
                ].map((col) => (
                  <TableCell
                    key={col}
                    sx={{
                      bgcolor: theme.palette.primary.main,
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: "0.8rem",
                      borderBottom: "none",
                    }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {priorityRows.map((row, idx) => {
                const segments = [
                  { label: "Retention", text: row.retention },
                  { label: "Growth", text: row.growth },
                  { label: "Service", text: row.service },
                ].filter((s) => {
                  const t = (s.text ?? "").toString().trim();
                  return t.length > 0 && t !== "—" && t !== "-";
                });

                return (
                  <React.Fragment key={row.priority || idx}>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          fontSize: "0.82rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {row.priority || "—"}
                      </TableCell>

                      <TableCell sx={{ fontSize: "0.82rem" }}>
                        {row.product || "—"}
                      </TableCell>

                      <TableCell sx={{ p: 0 }}>
                        {segments.length > 0 ? (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {segments.map((seg, subIdx) => (
                              <Box key={`${seg.label}-${subIdx}`}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 1,
                                    p: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      px: 1,
                                      py: 0.3,
                                      borderRadius: "999px",
                                      fontSize: "0.7rem",
                                      fontWeight: 600,
                                      bgcolor: "#f3f4f6",
                                      minWidth: 70,
                                      textAlign: "center",
                                    }}
                                  >
                                    {seg.label}
                                  </Box>

                                  <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: "0.78rem" }}>
                                      {seg.text}
                                    </Typography>
                                  </Box>
                                </Box>

                                {subIdx < segments.length - 1 && (
                                  <Box
                                    sx={{
                                      borderBottom: "1px solid #e5e7eb",
                                      mx: 1,
                                    }}
                                  />
                                )}
                              </Box>
                            ))}
                          </Box>
                        ) : (
                          <Box sx={{ p: 1.2 }}>
                            <Typography
                              sx={{
                                fontSize: "0.78rem",
                                color: "#6b7280",
                                fontStyle: "italic",
                              }}
                            >
                              —
                            </Typography>
                          </Box>
                        )}
                      </TableCell>

                      <TableCell sx={{ fontSize: "0.82rem" }}>
                        {row.lead || "—"}
                      </TableCell>
                    </TableRow>

                    {idx < priorityRows.length - 1 && (
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          sx={{ p: 0, borderBottom: "2px solid #d1d5db" }}
                        />
                      </TableRow>
                    )}
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ClientPriorityTableSection;
